import { Container, BitmapText } from '@pixi/react'
import { Panel } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { Image } from '@slot-nx/core'
import { Assets } from 'pixi.js'

import mainTabNormal from '../../../asset/images/godzidrop/btn_mg_normal.png'
import mainTabHover from '../../../asset/images/godzidrop/btn_mg_hover.png'
import mainTabPress from '../../../asset/images/godzidrop/btn_mg_pressed.png'
import mainTabDisabled from '../../../asset/images/godzidrop/btn_mg_disable.png'
import godziTabNormal from '../../../asset/images/godzidrop/btn_godzi_normal.png'
import godziTabHover from '../../../asset/images/godzidrop/btn_godzi_hover.png'
import godziTabPress from '../../../asset/images/godzidrop/btn_godzi_pressed.png'
import godziTabDisabled from '../../../asset/images/godzidrop/btn_godzi_disable.png'
import ticket from '../../../asset/images/godzidrop/image_ticket.png'
import ticketTitle from '../../../asset/images/godzidrop/image_multiplier.png'
import ticketTitleFreeSpin from '../../../asset/images/godzidrop/image_freeGame.png'
import ticketIcon from '../../../asset/images/godzidrop/image_x.png'
import { GodziType } from '../../domain/godziDrop/enum/godziDropEnum'

const godziImage = {
  mainTabNormal: { src: mainTabNormal, loadParser: 'loadTextures' },
  mainTabHover: { src: mainTabHover, loadParser: 'loadTextures' },
  mainTabPress: { src: mainTabPress, loadParser: 'loadTextures' },
  godziTabNormal: { src: godziTabNormal, loadParser: 'loadTextures' },
  godziTabHover: { src: godziTabHover, loadParser: 'loadTextures' },
  godziTabPress: { src: godziTabPress, loadParser: 'loadTextures' },
  godziTabDisabled: { src: godziTabDisabled, loadParser: 'loadTextures' },
  mainTabDisabled: { src: mainTabDisabled, loadParser: 'loadTextures' },
  ticket: { src: ticket, loadParser: 'loadTextures' },
  ticketTitle: { src: ticketTitle, loadParser: 'loadTextures' },
  ticketTitleFreeSpin: { src: ticketTitleFreeSpin, loadParser: 'loadTextures' },
  ticketIcon: { src: ticketIcon, loadParser: 'loadTextures' },
}
Assets.addBundle('godziImage', godziImage)

interface GodziTicketProps {
  godziType: GodziType
  payout: number
  prize: number
  width: number
}

export const GodziTicket = (props: GodziTicketProps) => {
  return (
    <Container>
      <Panel
        name="GodziTicketBackGround"
        x={10}
        y={195}
        width={props.width - 20}
        height={1690}
        border={{ color: '#4E0802', width: 3 }}
        radius={5}
        backgroundColor="#4E0802"
      />
      <TicketDisplay
        type={props.godziType}
        payout={props.payout}
        prize={props.prize}
      />
    </Container>
  )
}

interface TicketDisplayProps {
  type: GodziType
  payout: number
  prize: number
}

const TicketDisplay = (props: TicketDisplayProps) => {
  const displayNumber = props.type === GodziType.RatioPrize ? props.prize.toString() : props.payout.toString()
  const x = props.type === GodziType.RatioPrize ? gameConfig.resolution.width / 2 + 50 : gameConfig.resolution.width / 2
  return (
    <Container>
      <Image
        image="ticket"
        name="godzi ticket"
        width={600}
        height={600}
        x={gameConfig.resolution.width / 2 - 300}
        y={gameConfig.resolution.height / 2 - 300}
      />
      {props.type === GodziType.RatioPrize
        ? (
            <Image
              name="ticketTitle"
              image="ticketTitle"
              width={350}
              height={63}
              x={gameConfig.resolution.width / 2 - 175}
              y={gameConfig.resolution.height / 2 - 100}
            />
          )
        : (
            <Image
              name="ticketTitleFreeSpin"
              image="ticketTitleFreeSpin"
              width={300}
              height={111}
              x={gameConfig.resolution.width / 2 - 150}
              y={830}
            />
          )}

      {props.type === GodziType.RatioPrize
      && (
        <Image
          name="ticketIcon"
          image="ticketIcon"
          width={60}
          height={60}
          x={gameConfig.resolution.width / 2 - 180}
          y={gameConfig.resolution.height / 2}
        />
      )}
      <BitmapText
        text={displayNumber}
        anchor={[0.5, 0.5]}
        style={{ fontName: 'GodziFont', fontSize: 25 }}
        x={x}
        y={gameConfig.resolution.height / 2}
      />

    </Container>
  )
}
